import React, { useEffect, useState, useRef } from 'react';
const NAMES = ['Juan', 'Carlos', 'Martín', 'Roberto', 'Diego', 'Pablo', 'Sergio', 'Andrés', 'Fernando', 'Miguel', 'Gustavo', 'Raúl', 'Eduardo', 'Hernán', 'Facundo', 'Alejandro', 'Nicolás', 'Damián', 'Oscar', 'Ramiro'];
const PROVINCES = ['Buenos Aires', 'Córdoba', 'Santa Fe', 'Mendoza', 'Tucumán', 'Entre Ríos', 'Salta', 'Misiones', 'Chaco', 'San Juan', 'Jujuy', 'Río Negro', 'Neuquén', 'La Pampa', 'San Luis'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function scrollToCompra() {
  const el = document.getElementById('compra');
  if (el) el.scrollIntoView({
    behavior: 'smooth'
  });
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [exiting, setExiting] = useState(false);
  const [name, setName] = useState('');
  const [province, setProvince] = useState('');
  const [isCompleto, setIsCompleto] = useState(false);
  const showCompleto = useRef(false);
  useEffect(() => {
    const showPopup = () => {
      setName(getRandomItem(NAMES));
      setProvince(getRandomItem(PROVINCES));
      showCompleto.current = !showCompleto.current;
      setIsCompleto(showCompleto.current);
      setExiting(false);
      setVisible(true);
      setTimeout(() => {
        setExiting(true);
        setTimeout(() => {
          setVisible(false);
          scheduleNext();
        }, 500);
      }, 4000);
    };
    const scheduleNext = () => {
      const delay = 8000 + Math.random() * 4000;
      setTimeout(showPopup, delay);
    };
    const initialDelay = setTimeout(showPopup, 5000);
    return () => clearTimeout(initialDelay);
  }, []);
  if (!visible) return null;
  const packName = isCompleto ? 'Pack Completo' : 'Mega Pack';
  return <button onClick={scrollToCompra} className={`fixed bottom-4 left-4 z-50 rounded-lg shadow-2xl p-4 max-w-xs cursor-pointer transition-shadow ${exiting ? 'popup-exit' : 'popup-enter'} ${isCompleto ? 'bg-gradient-to-r from-amber-950 to-gray-900 border-2 border-amber-500' : 'bg-white border border-gray-200'}`} data-id="element-323">
      <div className="flex items-center gap-3" data-id="element-324">
        <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${isCompleto ? 'bg-amber-500' : 'bg-green-500'}`} data-id="element-325">
          <span className="text-white text-lg" data-id="element-326">{isCompleto ? '🏆' : '🛒'}</span>
        </div>
        <div className="text-left" data-id="element-327">
          <p className={`text-sm font-bold ${isCompleto ? 'text-amber-300' : 'text-gray-900'}`} data-id="element-328">
            {name} de {province}
          </p>
          <p className={`text-xs ${isCompleto ? 'text-amber-100' : 'text-gray-600'}`} data-id="element-329">
            acaba de comprar el {packName}
          </p>
          {isCompleto && <span className="inline-block bg-amber-500 text-black text-[10px] font-bold px-2 py-0.5 rounded-full mt-1" data-id="element-330">
              PACK COMPLETO ⭐
            </span>}
          <p className={`text-xs font-semibold mt-0.5 ${isCompleto ? 'text-amber-400' : 'text-green-600'}`} data-id="element-331">
            Hace {Math.floor(Math.random() * 5) + 1} minutos
          </p>
        </div>
      </div>
    </button>;
}